import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImageCacheService } from './imagecache.service';
import { ImageViewerComponent } from './imageviewer.component';
import { ImageViewerConfig, IMAGEVIEWER_CONFIG, IMAGEVIEWER_CONFIG_DEFAULT } from './imageviewer.config';
export class ImageViewerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [ImageViewerComponent],
  providers: [{
    provide: IMAGEVIEWER_CONFIG,
    useValue: IMAGEVIEWER_CONFIG_DEFAULT
  }, ImageCacheService],
  exports: [ImageViewerComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ImageViewerModule_tsickle_Closure_declarations() {
/** @type {?} */
ImageViewerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ImageViewerModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
